<template>
    <section class="container">
        <div class="row">
            <div class="kt-portlet col-12">
                <div class="alert alert-primary text-center" v-if="listo" v-html="texto"></div>
                <div v-else >
                    <div class="kt-portlet__head">
                        <div class="kt-portlet__head-label">
                            <h3 class="kt-portlet__head-title">
                                Actualice sus datos en el siguiente formulario
                            </h3>
                        </div>
                        <div class="kt-portlet__head-toolbar">
                            <router-link tag="button" class="btn btn-link" :to="{name:'datosPersonales.contraseña'}"><i class="flaticon-cogwheel"></i> Configuración</router-link>
                        </div>
                    </div>
                    <form class="kt-form"  @submit.prevent="validar" data-vv-scope="form-1" >
                        <fieldset class="kt-portlet__body" :disabled="cargando">
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-12 col-form-label">
                                    Cédula de identidad
                                </label>
                                <div class="col-md-9 col-sm-12 d-flex align-items-center">
                                    <span class="kt-widget13__text kt-widget13__text--bold">{{formulario.ci}}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-12 col-form-label" for="nombres">
                                    <i class="fa fa-asterisk text-danger"></i>
                                    Nombres
                                </label>
                                <div class="col-md-9 col-sm-12">
                                    <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Nombres"
                                            name="nombres"
                                            id="nombres"
                                            v-validate="{required:true,alpha_spaces:true,max:50}"
                                            v-model="formulario.nombres"
                                    />
                                    <span class="form-text text-danger">{{ errors.first('form-1.nombres') }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-12 col-form-label" for="apellidos">
                                    <i class="fa fa-asterisk text-danger"></i>
                                    Apellidos
                                </label>
                                <div class="col-md-9 col-sm-12">
                                    <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Apellidos"
                                            name="apellidos"
                                            id="apellidos"
                                            v-validate="{required:true,alpha_spaces:true,max:50}"
                                            v-model="formulario.apellidos"
                                    />
                                    <span class="form-text text-danger">{{ errors.first('form-1.apellidos') }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-12 col-form-label" for="email">
                                    <i class="fa fa-asterisk text-danger"></i>
                                    Email
                                </label>
                                <div class="col-md-9 col-sm-12">
                                    <input
                                            type="email"
                                            class="form-control"
                                            placeholder="sample@sample.com"
                                            name="email"
                                            id="email"
                                            v-validate="{required:true,email:true,max:50}"
                                            v-model="formulario.email"
                                    />
                                    <span class="form-text text-danger">{{ errors.first('form-1.email') }}</span>
                                </div>
                            </div>
                            <div class="row">
                                <label class="col-md-3 col-sm-12 col-form-label"><i class="fa fa-asterisk text-danger"></i>Tipo de email</label>
                                <div class="form-group col-md-9 col-sm-12">
                                    <combo-box v-model="formulario.tipoEmail" :opciones="tipoEmail" name="tipo email" v-validate="{required:true,obj:true}"></combo-box>
                                    <span class="form-text text-danger">{{errors.first("form-1.tipo email")}}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-12 col-form-label" for="teléfono">
                                    <i class="fa fa-asterisk text-danger"></i>
                                    Teléfono celular
                                </label>
                                <div class="col-md-9 col-sm-12">
                                    <input
                                            type="tel"
                                            class="form-control"
                                            placeholder="0998877665"
                                            name="teléfono"
                                            id="teléfono"
                                            v-validate="{required:true,...valTelf.celular}"
                                            v-model="formulario.telefono"
                                    />
                                    <span class="form-text text-danger">{{ errors.first('form-1.teléfono') }}</span>
                                </div>
                            </div>
                            <div class="row">
                                <label class="col-md-3 col-sm-12 col-form-label"><i class="fa fa-asterisk text-danger"></i>Tipo de teléfono</label>
                                <div class="form-group col-md-9 col-sm-12">
                                    <combo-box v-model="formulario.tipoTelf" :opciones="tipoTelf" name="tipo teléfono" v-validate="{required:true,obj:true}"></combo-box>
                                    <span class="form-text text-danger">{{errors.first("form-1.tipo teléfono")}}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-12 col-form-label">
                                    <i class="fa fa-asterisk text-danger"></i>
                                    Dirección
                                </label>
                                <div class="col-md-9 col-sm-12 p-0 m-0">
                                    <div class="row m-0">
                                        <div class="col-md-6 col-sm-6 pb-4">
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Calle Principal"
                                                    name="calle principal"
                                                    id="callep"
                                                    v-validate="{required:true,max:50}"
                                                    v-model="formulario.calle1"
                                            />
                                            <span class="form-text text-danger">{{ errors.first('form-1.calle principal') }}</span>
                                        </div>
                                        <div class="col-md-6 col-sm-6 pb-4">
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Calle Secundaria"
                                                    name="calle secundaria"
                                                    id="calle secundaria"
                                                    v-validate="{required:true,max:50}"
                                                    v-model="formulario.calle2"
                                            />
                                            <span class="form-text text-danger">{{ errors.first('form-1.calle secundaria') }}</span>
                                        </div>
                                        <div class="col-12 p-md-1"></div>
                                        <div class="col-md-3 col-sm-4 pb-4">
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Número"
                                                    name="número"
                                                    id="número"
                                                    v-validate="{required:true,max:50}"
                                                    v-model="formulario.numero"
                                            />
                                            <span class="form-text text-danger">{{ errors.first('form-1.número') }}</span>
                                        </div>
                                        <div class="col-md-4 col-sm-4 pb-4">
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Barrio"
                                                    name="barrio"
                                                    id="barrio"
                                                    v-model="formulario.barrio"
                                                    v-validate="{max:50}"
                                            />
                                            <span class="form-text text-danger">{{ errors.first('form-1.barrio') }}</span>
                                        </div>
                                        <div class="col-md-5 col-sm-4 pb-4">
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Referencia"
                                                    name="referencia"
                                                    id="referencia"
                                                    v-model="formulario.referencia"
                                                    v-validate="{max:50}"
                                            />
                                            <span class="form-text text-danger">{{ errors.first('form-1.referencia') }}</span>
                                        </div>

                                        <div class="col-12 p-md-1"></div>
                                        <div class="form-group col-md-4 col-sm-12">
                                            <combo-box v-model="formulario.tipoDir" :opciones="tipoDir" name="tipo dirección" v-validate="{required:true,obj:true}"></combo-box>
                                            <span class="form-text text-danger">{{errors.first("form-1.tipo dirección")}}</span>
                                        </div>
                                        <div class="form-group col-md-4 col-sm-12">
                                            <combo-box v-model="formulario.tipoCanton" :opciones="cantones" name="ciudad" v-validate="{required:true,obj:true}"></combo-box>
                                            <span class="form-text text-danger">{{errors.first("form-1.ciudad")}}</span>
                                        </div>
                                        <div class="form-group col-md-4 col-sm-12">
                                            <combo-box v-model="formulario.tipoParro" :opciones="parroquias" name="parroquia"></combo-box>
                                            <span class="form-text text-danger">{{errors.first("form-1.parroquía")}}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </fieldset>
                        <div class="kt-portlet__foot ">
                            <div class="kt-form__actions">
                                <div class="row">
                                    <div class="col-md-3 col-sm-12"></div>
                                    <div class="col-md-9 col-sm-12">
                                        <button
                                                type="submit"
                                                :disabled="cargando"
                                                :class="cargando && 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light'"
                                                class="btn btn-brand btn-md btn-tall btn-wide kt-font-bold"
                                        >
                                            Actualizar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import constantes from "../../constantes";
    import comboBox from "../../componentes/comboBox";
    import {prospecto,catalogos} from "../../servicios";
    import _ from 'lodash';
    export default {
        name: "datosPersonales",
        data:()=>({
            formulario:{
                ci:null,
                nombres:null,
                apellidos:null,
                telefono:null,
                email:null,
                fecha:null,
                genero:null,
                calle1:null,
                calle2:null,
                referencia:null,
                numero:null,
                barrio:null,
                tipoTelf:null,
                tipoEmail:null,
                tipoCanton:null,
                tipoParro:null,
                tipoDir:null,
            },
            cargando:false,
            listo:false,
            texto:constantes.Constantes.formularioCompleto,
            valTelf:constantes.Constantes.validacion,
            tipoEmail:[],
            tipoTelf:[],
            tipoDir:[],
            cantones:[],
            parroquias:[],
            respuesta:{},
        }),
        components:{
            comboBox
        },
        watch:{
            "formulario.tipoTelf":function(val){
                const aux = this.respuesta.elements3.find(i=> i.ndt1===val.id);
                this.formulario.telefono=aux ? aux.dt1 : null;
            },
            "formulario.tipoEmail":function(val){
                const aux = this.respuesta.elements2.find(i=> i.ndt1===val.id);
                this.formulario.email=aux ? aux.dt1 : null;
            },
            "formulario.tipoCanton":function(canton){
                this.formulario.tipoParro = {id:null};
                if(canton){
                    this.parroquias = [];
                    this.parroquias = canton.elements || [];
                }
            },
        },
        methods: {
            validar:function(){
                this.$validator.validateAll('form-1').then((result) => {
                    this.cargando = true;
                    if (result) {
                        this.enviarDatos();
                    } else {
                        this.cargando = false;
                        this.$toast.show(`Completa el formulario`);
                    }
                });
            },
            enviarDatos:_.debounce(function(){
                prospecto.actualizar(this.formulario).then(()=>{
                    this.$store.dispatch('regenerar');
                    this.cargarDatos();
                    this.cargando=false;
                    this.$toast.info(`Se ha actualizado sus datos personales`);
                }).catch(()=>{
                    this.cargando=false;
                });
            },2000),
            cargarCatalogos:async function(){
                await catalogos.tipoEmail().then(r=>r.data).then(emails=>{
                    this.tipoEmail=emails;
                });
                await catalogos.tipoTelefono().then(r=>r.data).then(telefonos=>{
                    this.tipoTelf=telefonos.filter(x=>x.dt1.toLowerCase().includes("movil"));
                });
                await catalogos.tipoDireccion().then(r=>r.data).then(direcciones=>{
                    this.tipoDir=direcciones;
                });
                await catalogos.proviniasConChill().then(r=>r.data).then(provincias=>{
                    provincias.map(i=>{
                        this.cantones=this.cantones.concat(i.elements);
                    });
                })
            },
            cargarDatos:function(){
                this.formulario.ci=this.$store.getters.getDni;
                prospecto.informacion().then(r=>r.data).then(response=>{
                    this.respuesta=response;
                    this.formulario.nombres=`${response.dt1} ${response.dt2}`;
                    this.formulario.apellidos=`${response.dt3} ${response.dt4}`;
                    this.formulario.tipoEmail=this.tipoEmail.find(i=> i.id===response.elements2.find(j=> j.bdt2===true).ndt1);
                    this.formulario.fecha=constantes.funciones.formatoFechaInverso(response.ddt2);
                    const j = response.elements3.findIndex(a=> a.bdt2===true);
                    const i= this.tipoTelf.findIndex(b=> b.id===response.elements3[j].ndt1);
                    if(i===-1){
                        this.respuesta.elements3[j].ndt1=this.tipoTelf[0].id;
                        this.formulario.tipoTelf=this.tipoTelf[0];
                    }else{
                        this.formulario.tipoTelf=this.tipoTelf[i];
                    }
                    try {
                        const k = response.elements4.findIndex(j=> j.bdt2===true);
                        this.formulario.calle1=response.elements4[k].dt1;
                        this.formulario.calle2=response.elements4[k].dt2;
                        this.formulario.numero=response.elements4[k].dt3;
                        this.formulario.referencia=response.elements4[k].dt4;
                        this.formulario.barrio=response.elements4[k].dt5;
                        this.formulario.tipoDir=this.tipoDir.find(i=> i.id===response.elements4[k].ndt1);
                        this.formulario.tipoCanton=this.cantones.find(i=> i.id===response.elements4[k].ndt2);
                        setTimeout(()=>{
                            this.formulario.tipoParro=this.formulario.tipoCanton.elements.find(i=> i.id===response.elements4[k].ndt3);
                        },500);
                    }catch (e) {
                        //
                    }
                });
            },
        },
        async mounted() {
            await this.cargarCatalogos();
            this.cargarDatos();
        },
    }
</script>

<style scoped>

</style>
